import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { OrderState, OrderStateItem, OrderStateList } from '@lfw/roesberg.liveforms.core';

export class stateTranslator {
  public static async translateStates(translate: TranslateService) {
    await this.translateItem(translate, OrderStateList.undefinedItem);
    for (const state of OrderStateList.states) {
      await this.translateItem(translate, state);
    }
  }

  static async translateItem(translate: TranslateService, item: OrderStateItem) {
    const enumText = 'ORDERSTATES.' + OrderState[item.state].toUpperCase();
    item.text = await firstValueFrom(translate.get(enumText));
  }
}
